import { render, staticRenderFns } from "./SocialConnection.vue?vue&type=template&id=3a1d01b0&scoped=true&"
import script from "./SocialConnection.vue?vue&type=script&lang=ts&"
export * from "./SocialConnection.vue?vue&type=script&lang=ts&"
import style0 from "./SocialConnection.vue?vue&type=style&index=0&id=3a1d01b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1d01b0",
  null
  
)

export default component.exports